import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
} from "@reduxjs/toolkit";
import homeReducer from "../features/home/homeSlice";
import gamesReducer from "../features/games/gamesSlice";
import gameReducer from "../features/game/gameSlice";
import progressReducer from "../features/progress/progressSlice";
import settingsReducer, { migrateSettings } from "../features/settings/settingsSlice";

import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const reducers = combineReducers({
  home: homeReducer,
  games: gamesReducer,
  game: gameReducer,
  progress: progressReducer,
  settings: settingsReducer,
});

const persistConfig = {
  key: "root",
  storage,
  version: 1,
  migrate: (state: any) => Promise.resolve(migrateSettings(state)),
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoreActions: true,
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
